import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { PurchaseOperationUnreconciledService } from '@core/services/entities/purchase-operation-unreconciled.service';
import { PurchaseOperationResponseDto } from '@domain/purchase-operation/dtos/purchase-operation.response.dto';
import { PurchaseOperationUnreconciledRepository } from '@domain/purchase-operation-unreconciled/repositories/purchase-operation-unreconciled.repository';
import { Observable } from 'rxjs';
import { RefId } from '@core/interface/ref-id.interface';

@Injectable({
  providedIn: 'root',
})
export class PurchaseOperationUnreconciledRepositoryService implements PurchaseOperationUnreconciledRepository {
  constructor(private purchaseOperationUnreconciledService: PurchaseOperationUnreconciledService) {}

  show(request: RefId): Observable<ApiResponse<PurchaseOperationResponseDto>> {
    return this.purchaseOperationUnreconciledService.show(request);
  }

  reconcile(
    request: { operationRefId: string; transactionRefId?: string },
  ): Observable<ApiResponse<{ message: string }>> {
    return this.purchaseOperationUnreconciledService.reconcile(request);
  }
}
